// extracted by mini-css-extract-plugin
module.exports = {"bottomMenu":"SideMenu_bottomMenu__1n_iq","rightMenu":"SideMenu_rightMenu__3Uodh","icon":"SideMenu_icon__G6N4L"};